import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: [],
    success:null
  },
  action
) {
  switch (action.type) {
    case homeConstants.PRODUCTS_SEARCH_REQUEST:
      return {
        ...state,
        isProgress: true,
        success:null
      };
    case homeConstants.PRODUCTS_SEARCH_SUCCESS: {
      let result = [];
      if (action.response && action.response.data) {
        result = action.response.data.map((item) => {
          return {
            ...item,
            productId: item.id,
          };
        });
      }
      return {
        ...state,
        data: result,
        isProgress: false,
        success:action.response.success
      };
    }
    case homeConstants.PRODUCTS_SEARCH_FAILURE:
      return {
        ...state,
        data: [],
        error: action.error,
        isProgress: false,
        success:false
      };
    case homeConstants.RESET_DATA: {
      if (action.data === "productReset") {
        return {
          ...state,
          data: [],success:null
        };
      } else {
        return {
          ...state,success:null
        };
      }
    }
    case homeConstants.RESET_APPLICATION:
      return {
        ...state,
        data: [],
        isProgress: false,
        success:null
      };
    default:
      return state;
  }
}
